import {
  ApiAction,
  ApiRequestAction,
  ApiSuccessAction,
  ApiFailureAction,
} from 'lib/types/global';
import { Session, SessionError } from 'lib/types/session';
import {
  API_LOGIN,
  API_LOGIN_REQUEST,
  API_LOGIN_SUCCESS,
  API_LOGIN_FAILURE,
  API_LOGOUT,
  API_LOGOUT_REQUEST,
  API_LOGOUT_SUCCESS,
  API_LOGOUT_FAILURE,
  API_READ_SESSION,
  API_READ_SESSION_REQUEST,
  API_READ_SESSION_SUCCESS,
  API_READ_SESSION_FAILURE,
} from './actionTypes';

type ApiLoginAction = ApiAction<API_LOGIN>;
type ApiLoginRequestAction = ApiRequestAction<API_LOGIN_REQUEST>;
export type ApiLoginSuccessAction = ApiSuccessAction<
  API_LOGIN_SUCCESS,
  Session
>;
type ApiLoginFailureAction = ApiFailureAction<API_LOGIN_FAILURE, SessionError>;

type ApiLogoutAction = ApiAction<API_LOGOUT>;
type ApiLogoutRequestAction = ApiRequestAction<API_LOGOUT_REQUEST>;
type ApiLogoutSuccessAction = ApiSuccessAction<API_LOGOUT_SUCCESS>;
type ApiLogoutFailureAction = ApiFailureAction<API_LOGOUT_FAILURE>;

type ApiReadSessionAction = ApiAction<API_READ_SESSION>;
type ApiReadSessionRequestAction = ApiRequestAction<API_READ_SESSION_REQUEST>;
type ApiReadSessionSuccessAction = ApiSuccessAction<
  API_READ_SESSION_SUCCESS,
  Session
>;
type ApiReadSessionFailureAction = ApiFailureAction<
  API_READ_SESSION_FAILURE,
  SessionError
>;

export const login = (email: string, password: string): ApiLoginAction => ({
  endpoint: '/api/session',
  type: API_LOGIN,
  options: {
    method: 'post',
    body: {
      email,
      password,
    },
  },
});

export const logout = (): ApiLogoutAction => ({
  endpoint: '/api/session',
  type: API_LOGOUT,
  options: {
    method: 'delete',
  },
});

export const readSession = (): ApiReadSessionAction => ({
  endpoint: '/api/session',
  type: API_READ_SESSION,
});

export type SessionAction =
  | ApiLoginAction
  | ApiLoginRequestAction
  | ApiLoginSuccessAction
  | ApiLoginFailureAction
  | ApiLogoutAction
  | ApiLogoutRequestAction
  | ApiLogoutSuccessAction
  | ApiLogoutFailureAction
  | ApiReadSessionAction
  | ApiReadSessionRequestAction
  | ApiReadSessionSuccessAction
  | ApiReadSessionFailureAction;
